import { useAnimate } from "@mui/x-charts";
import { interpolateObject } from '@mui/x-charts-vendor/d3-interpolate'
import { styled } from '@mui/material/styles';;

const Text = styled('text')(({ theme }) => ({
    ...theme?.typography?.body2,
    stroke: 'none',
    transition: 'opacity 0.2s ease-in, fill 0.2s ease-in',
    textAnchor: 'start',
    dominantBaseline: 'central',
    pointerEvents: 'none',
    fontWeight: 600,
}));

export default function BarLabelAtBase(props) {
    const {
        seriesId,
        dataIndex,
        color,
        isFaded,
        isHighlighted,
        classes,
        xOrigin,
        yOrigin,
        x,
        y,
        width,
        height,
        layout,
        skipAnimation,
        children,
        ...otherProps
    } = props;

    // Estimate text width (approx 8px per char for typical font size)
    const textContent = children ? children.toString() : '';
    const estimatedTextWidth = textContent.length * 8; 
    const padding = 20; // Buffer space
    const fitsInside = width > (estimatedTextWidth + padding);
    
    // If fits inside, place at start of bar (white text)
    // If not, place outside to the right of bar (black text)
    const finalX = fitsInside ? (xOrigin + 8) : (xOrigin + width + 8);
    const textColor = fitsInside ? '#ffffff' : '#000000';

    const animatedProps = useAnimate(
        { x: finalX, y: y + height / 2 },
        {
            initialProps: { x: finalX, y: y + height / 2 },
            createInterpolator: interpolateObject,
            transformProps: (p) => p,
            applyProps: (element, p) => {
                element.setAttribute('x', p.x.toString());
                element.setAttribute('y', p.y.toString());
            },
            skip: skipAnimation,
        },
    );

    return (
        <Text 
            {...otherProps} 
            {...animatedProps} 
            style={{ fill: textColor }}
        >
            {children}
        </Text>
    );
}